interface StringConstructor {
  IsNullOrEmpty: (str?: string) => boolean;
}

String.IsNullOrEmpty = (str): boolean => {
  return str === '' || str === null || str === undefined || (typeof str === 'string' && str.trim().length == 0);
}